
// import React, { useState } from 'react';
// import { useNavigate } from "react-router-dom";
// import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// import itImage from '../img/aaaservices/PYTHON V1.jpg';
// import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

// import mechImg from '../img/aaaservices/VR.webp';
// import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
// import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
// import itImg1 from '../img/aaaservices/PY.jpg';
// import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
// import dfsImg from '../img/aaaservices/F.png';
// import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
// import dfsImg2 from '../img/aaaservices/s.png';
// import dfsImg3 from '../img/aaaservices/d.webp';

// const styles = {
//   container: {
//     position: 'relative',
//     width: '100%',
//     maxWidth: '600px',
//     padding: '50px 0',
//     margin: 'auto',
//   },
//   labelContainer: {
//     position: 'absolute',
//     top: 37,
//     transform: 'translateX(-50%)',
//     zIndex: 2,
//   },
//   pin: {
//     // backgroundColor: 'orange',
//     color: '#fff',
//     padding: '5px 10px',
//     borderRadius: '50% 50% 50% 0',
//     transform: 'rotate(-45deg)',
//     width: '40px',
//     height: '40px',
//     textAlign: 'center',
//     lineHeight: '30px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     marginTop:'265px',
//     marginLeft:'56px'
//   },
//   pinText: {
//     transform: 'rotate(45deg)',
//     fontWeight: 'bold',
//     color: '#1f78ff',
//   },
//   slider: {
//     width: '100%',
//     height: '8px',
//     borderRadius: '4px',
//     background: '#e4e4ee',
//     appearance: 'none',
//     outline: 'none',
//     position: 'relative',
//     zIndex: 1,
//      marginTop:'36px'
    
//   }
// };

// const cardData = {
//   Mechanical: [
//     { id: 1, title: "Virtual Robotics", subtitle: "Simulated Automation", date: "2025-06-01", time: "10:00 AM - 4:00 PM", cost: "₹150", image: mechImg, link: "/Virtualpage" },
//     { id: 2, title: "Tool & fixture design",
//       name: "Jane Smith",
//       subtitle: "3D Product Design",
//       date: "2025-06-05",
//       time: "11:00 AM - 5:00 PM",
//       cost: "₹120",
//       image: simImg ,
//       link: "/fixture", },

//     { id: 3,  title: "Digital Factory",
//       name: "Mike Johnson",
//       subtitle: "Smart Production",
//       date: "2025-06-10",
//       time: "9:00 AM - 3:00 PM",
//       cost: "₹180",
//       image: dfsImg,
//       link: "/DigitalC",
//     },
//     // { id: 4, title: "Mech Card 4", subtitle: "Subtitle 4", date: "May 23", time: "3:00 PM", cost: "₹120", image: mechImage },
//     // { id: 5, title: "Mech Card 5", subtitle: "Subtitle 5", date: "May 24", time: "2:00 PM", cost: "₹95", image: mechImage },
//     // { id: 6, title: "Mech Card 6", subtitle: "Subtitle 6", date: "May 25", time: "1:00 PM", cost: "₹130", image: mechImage }
//   ],
//   IT: [
//     { id: 1, title: "Java Full-Stack-Devlopers",
//      subtitle: "Subtitle 2",
//       date: "2025-06-17",
//       time: "1:00 PM - 6:00 PM",
//       cost: "₹350",
//       image: itImg,
//       link: "/it-services",
//     }, 
//     { id: 2, title: "Python Full-Stack-Devlopers",
//      subtitle: "Subtitle 2",
//       date: "2025-06-19",
//       time: "10:00 AM - 2:00 PM",
//       cost: "₹300",
//       image: itImg1,
//       link: "/Puthonpage", },

//     { id: 3, title: "React & Flutter-Devlopers",
//     subtitle: "Subtitle 2",
//       date: "2025-06-19",
//       time: "10:00 AM - 2:00 PM",
//       cost: "₹300",
//       image: itImg2,
//       link: "/Reactpage", },

//     // { id: 4, title: "IT Card 4", subtitle: "Subtitle 4", date: "May 23", time: "3:00 PM", cost: "₹120", image: itImage },
//     // { id: 5, title: "IT Card 5", subtitle: "Subtitle 5", date: "May 24", time: "2:00 PM", cost: "₹95", image: itImage },
//     // { id: 6, title: "IT Card 6", subtitle: "Subtitle 6", date: "May 25", time: "1:00 PM", cost: "₹130", image: itImage }
//   ],
//   Digital: [
//     { id: 1, title: "Career foundation Skills",
//       subtitle: "Subtitle 2",
//       date: "2025-06-21",
//       time: "10:00 AM - 4:00 PM",
//       cost: "₹400",
//       image:  dfsImg1,
//       link: "/Outdoor", },

//     { id: 2, title: "Soft Skill Enhancements",
//      subtitle: "Subtitle 2",
//       date: "2025-06-22",
//       time: "9:00 AM - 1:00 PM",
//       cost: "₹450",
//       image: dfsImg2,
//       link: "/Sopftskillpage", },
//     { id: 3, title: "Digital Presence Skills",
//      subtitle: "Subtitle 2",
//       date: "2025-06-22",
//       time: "9:00 AM - 1:00 PM",
//       cost: "₹450",
//       image: dfsImg3 ,
//       link: "/Digitalpresenceskillpage", },
//     // { id: 4, title: "Digital Card 4", subtitle: "Subtitle 4", date: "May 23", time: "3:00 PM", cost: "₹120", image: digitalImage },
//     // { id: 5, title: "Digital Card 5", subtitle: "Subtitle 5", date: "May 24", time: "2:00 PM", cost: "₹95", image: digitalImage },
//     // { id: 6, title: "Digital Card 6", subtitle: "Subtitle 6", date: "May 25", time: "1:00 PM", cost: "₹130", image: digitalImage }
//   ]
// };

// const BranchFilterComponent = () => {
//   const [selectedBranch, setSelectedBranch] = useState('All');
//   const [dateFilter, setDateFilter] = useState("");
//   const [calendarDate, setCalendarDate] = useState("");
//   const [location, setLocation] = useState("");
//   const [language, setLanguage] = useState("");
//    const [price, setPrice] = useState(99);
//   const navigate = useNavigate();

//   const getFilteredData = () => {
//     let data = selectedBranch === 'All'
//       ? [...cardData.Mechanical, ...cardData.IT, ...cardData.Digital]
//       : cardData[selectedBranch] || [];

//     return data; // Add more filters here if needed later
//   };

//   return (
//     <div className="filter-container">
//       <div className="sidebar">
//         <h3 style={{fontFamily:'roboto',fontSize:'35px',margin:'-1px'}}>Filter</h3>
//         <select onChange={(e) => setSelectedBranch(e.target.value)} value={selectedBranch}>
//           <option value="All">All</option>
//           <option value="Mechanical">Mechanical</option>
//           <option value="IT">IT</option>
//           <option value="Digital">JOSE</option>
//         </select>

//         <select value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
//           <option value="">Date</option>
//           <option value="today">Today</option>
//           <option value="tomorrow">Tomorrow</option>
//           <option value="weekend">This Weekend</option>
//         </select>

//         <input type="date" value={calendarDate} onChange={(e) => setCalendarDate(e.target.value)} />

//         <select value={location} onChange={(e) => setLocation(e.target.value)}>
//           <option value="">Location</option>
//           <option value="hyderabad">Hyderabad</option>
//           <option value="bangalore">Bangalore</option>
//           <option value="chennai">Chennai</option>
//           <option value="mumbai">Mumbai</option>
//         </select>

//         <select value={language} onChange={(e) => setLanguage(e.target.value)}>
//           <option value="">Language</option>
//           <option value="english">English</option>
//           <option value="hindi">Hindi</option>
//           <option value="telugu">Telugu</option>
//           <option value="tamil">Tamil</option>
//         </select>

//          <div style={{ ...styles.labelContainer, left: `${(price - 99) / (60000 - 99) * 100}%` }}>
//         <div style={styles.pin}>
//           <span style={styles.pinText}>₹{price}</span>
//         </div>
//       </div>
//       <input
//         type="range"
//         min={99}
//         max={60000}
//         step={1}
//         value={price}
//         onChange={(e) => setPrice(Number(e.target.value))}
//         style={styles.slider}
//       />
//       </div>
    

//       <div className="card-section">
//         {getFilteredData().map((card) => (
//           <div className="card" key={card.id} onClick={() => navigate(card.link || "#")}>
//             <img src={card.image} alt={card.title} />
//             <div className="card-content">
//               <p style={{fontSize:'20px',color:'blue',fontFamily:'roboto',}}>{card.title}</p>
//               <p>{card.subtitle}</p>
//               <p>{card.date} | {card.time}</p>
//               <p>{card.cost}</p>
//             </div>
//           </div>
//         ))}
//       </div>

//       <style jsx>{`
//         .filter-container {
//           display: flex;
//           gap: 20px;
//           padding: 20px;
//           font-family: Arial, sans-serif;
//         }

//         .sidebar {
//           min-width: 260px;
//           position: sticky;
//           max-width:320px;
//           top: 172px;
//           background: #f9f9f9;
//           padding: 15px;
//           border-radius: 8px;
//           box-shadow: 0 0 10px rgba(0,0,0,0.1);
//           height: fit-content;
//         }

//         .sidebar h3 {
//           margin-bottom: 10px;
//           font-size: 20px;
//           color: #333;
//         }

//         .sidebar select,
//         .sidebar input[type="date"] {
//           width: 100%;
//           padding: 8px;
//           margin-bottom: 15px;
//           font-size: 15px;
//           border-radius: 5px;
//           border: 1px solid #ccc;
//         }

//         .card-section {
//           flex: 1;
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 20px;
//         }

//         .card {
//           background: #fff;
//           border-radius: 10px;
//           border: 1px solid #ddd;
//           overflow: hidden;
//           cursor: pointer;
//           transition: transform 0.2s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card img {
//           width: 100%;
//           height: 160px;
//           object-fit: cover;
//           padding:10px;
//           border-radius:20px;
//         }

//         .card-content {
//           padding: 8px 15px;
//           text-align: left;
//         }

//         .card-content h2 {
//           font-size: 20px;
//           font-weight: bold;
//           color: blue;
//         }

//         .card-content p {
        
//           color: black;
//         font-weight: bold;
         
//           font-family:math;
//           text-align:left;
//         }

//         @media (max-width: 992px) {
//           .card-section {
//             grid-template-columns: repeat(2, 1fr);
//           }
//         }

//         @media (max-width: 600px) {
//           .filter-container {
//             flex-direction: column;
//           }

//           .sidebar {
//             width: 100%;
//             position: relative;
//             top: auto;
//           }

//           .card-section {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default BranchFilterComponent;




import React, { useState } from 'react';
// import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
// import mechImage from '../img/aaaservices/TOOL & FIXTURE V1.jpg';
// import itImage from '../img/aaaservices/PYTHON V1.jpg';
// import digitalImage from '../img/aaaservices/DIGITAL FACILITY SIMULATIONS V3.jpg';

import mechImg from '../img/aaaservices/VR.webp';
import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
import itImg1 from '../img/aaaservices/PY.jpg';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
import dfsImg from '../img/aaaservices/F.png';
import dfsImg1 from '../img/aaaservices/Thumbnail-Skill-Based-Professions-1.png';
import dfsImg2 from '../img/aaaservices/s.png';
import dfsImg3 from '../img/aaaservices/d.webp';
import OnlyButtonrange from './OnlyButtonrange';
import Advertisment from './Advertisment';

const cardData = {
  Mechanical: [
    { id: 1, title: "Virtual Robotics", subtitle: "Simulated Automation", date: "2025-06-01", time: "10:00 AM - 4:00 PM", cost: "₹150", minPrice: 150, maxPrice: 150, location: "hyderabad", language: "english", image: mechImg, link: "/Virtualpage" },
    { id: 2, title: "Tool & Fixture Design", subtitle: "3D Product Design", date: "2025-06-05", time: "11:00 AM - 5:00 PM", cost: "₹120", minPrice: 100, maxPrice: 200, location: "bangalore", language: "hindi", image: simImg, link: "/fixture" },
    { id: 3, title: "Digital Factory", subtitle: "Smart Production", date: "2025-06-10", time: "9:00 AM - 3:00 PM", cost: "₹180", minPrice: 150, maxPrice: 250, location: "chennai", language: "telugu", image: dfsImg, link: "/DigitalC" },
  ],
  IT: [
    { id: 4, title: "Java Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-17", time: "1:00 PM - 6:00 PM", cost: "₹350", minPrice: 300, maxPrice: 400, location: "hyderabad", language: "english", image: itImg, link: "/it-services" },
    { id: 5, title: "Python Full-Stack Developers", subtitle: "Complete Stack", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹300", minPrice: 250, maxPrice: 350, location: "mumbai", language: "english", image: itImg1, link: "/Puthonpage" },
    { id: 6, title: "Flutter Developers", subtitle: "Cross-Platform Apps", date: "2025-06-19", time: "10:00 AM - 2:00 PM", cost: "₹300", minPrice: 250, maxPrice: 350, location: "bangalore", language: "tamil", image: itImg2, link: "/Reactpage" },
  ],
  Digital: [
    { id: 7, title: "Career Foundation Skills", subtitle: "Professional Basics", date: "2025-06-21", time: "10:00 AM - 4:00 PM", cost: "₹400", minPrice: 400, maxPrice: 500, location: "chennai", language: "telugu", image: dfsImg1, link: "/Outdoor" },
    { id: 8, title: "Soft Skill Enhancements", subtitle: "Communication Mastery", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹450", minPrice: 400, maxPrice: 500, location: "hyderabad", language: "english", image: dfsImg2, link: "/Sopftskillpage" },
    { id: 9, title: "Digital Presence Skills", subtitle: "Online Branding", date: "2025-06-22", time: "9:00 AM - 1:00 PM", cost: "₹450", minPrice: 400, maxPrice: 500, location: "mumbai", language: "hindi", image: dfsImg3, link: "/Digitalpresenceskillpage" },
  ]
};

const BranchFilterComponent = () => {
  const navigate = useNavigate();

  const [selectedBranch, setSelectedBranch] = useState('All');
  const [calendarDate, setCalendarDate] = useState('');
  const [location, setLocation] = useState('');
  const [language, setLanguage] = useState('');
  const [minPrice, setMinPrice] = useState('');
  const [maxPrice, setMaxPrice] = useState('');

  const getFilteredData = () => {
    let data = selectedBranch === 'All'
      ? [...cardData.Mechanical, ...cardData.IT, ...cardData.Digital]
      : cardData[selectedBranch] || [];

    if (calendarDate) {
      data = data.filter(card => card.date === calendarDate);
    }

    if (location) {
      data = data.filter(card => card.location === location);
    }

    if (language) {
      data = data.filter(card => card.language === language);
    }

    if (minPrice !== '') {
      data = data.filter(card => card.minPrice >= parseInt(minPrice));
    }

    if (maxPrice !== '') {
      data = data.filter(card => card.maxPrice <= parseInt(maxPrice));
    }

    return data;
  };

  return (
    <div className="filter-container">
      <div className="sidebar">
        <h3 style={{fontFamily:'sans-serif',fontSize:'20px',color:'blue',marginTop:'2px'}}>Filters</h3>

        <select value={selectedBranch} onChange={(e) => setSelectedBranch(e.target.value)}>
          <option value="All">All Branches</option>
          <option value="Mechanical">Mechanical</option>
          <option value="IT">IT</option>
          <option value="Digital">Jose</option>
        </select>

        <input type="date" value={calendarDate} onChange={(e) => setCalendarDate(e.target.value)} />

        <select value={location} onChange={(e) => setLocation(e.target.value)}>
          <option value="">Location</option>
          <option value="hyderabad">Hyderabad</option>
          <option value="bangalore">Bangalore</option>
          <option value="chennai">Chennai</option>
          <option value="mumbai">Mumbai</option>
        </select>

        <select value={language} onChange={(e) => setLanguage(e.target.value)}>
          <option value="">Language</option>
          <option value="english">English</option>
          <option value="hindi">Hindi</option>
          <option value="telugu">Telugu</option>
          <option value="tamil">Tamil</option>
        </select>

        <select value={minPrice} onChange={(e) => setMinPrice(e.target.value)}>
          <option value="">Min Price</option>
          <option value="100">100</option>
          <option value="200">200</option>
          <option value="300">300</option>
          <option value="400">400</option>
        </select>

        <select value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
          <option value="">Max Price</option>
          <option value="300">300</option>
          <option value="400">400</option>
          <option value="500">500</option>
        </select>
      </div>

      <div className="card-section">
        {getFilteredData().map((card) => (
          <div className="card" key={card.id} onClick={() => navigate(card.link)}>
            <img src={card.image} alt={card.title} />
            <div className="card-content">
              <p style={{ fontSize: '20px', color: 'blue', fontFamily: 'roboto' }}>{card.title}</p>
              <p>{card.subtitle}</p>
              <p>{card.date} | {card.time}</p>
              <p>{card.cost}</p>
             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
  <p style={{ marginRight: '10px' }}>{card.location}, {card.language}</p>
  <button style={{ 
    borderRadius: '10px', 
    backgroundColor: 'blue', 
    color: 'white',
    padding: '5px 15px',
    border: 'none',
    cursor: 'pointer'
  }}>
    Know More
  </button>
</div>

            </div>
          </div>
        ))}
      </div>

<Advertisment />
      <style jsx>{`
        .filter-container {
          display: flex;
          gap: 20px;
          padding: 20px;
          
        }

        .sidebar {
           min-width: 260px;
           position: sticky;
           max-width:320px;
           top: 172px;
           background: #f9f9f9;
          padding: 15px;
           border-radius: 8px;
           box-shadow: 0 0 10px rgba(0,0,0,0.1);
           height: fit-content;
         }

        .sidebar select,
        .sidebar input[type="date"] {
          width: 100%;
          padding: 8px;
          margin-bottom: 15px;
          font-size: 15px;
          border-radius: 5px;
          border: 1px solid #ccc;
        }

        .card-section {
          flex: 1;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .card {
          background: #fff;
          border-radius: 10px;
          border: 1px solid #ddd;
          height:347px;
          color:black;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .card:hover {
          transform: translateY(-5px);
        }

        .card img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          padding: 10px;
          border-radius: 20px;
        }

        .card-content {
          padding: 10px;
        }

        .card-content p {
          margin: 5px 0;
          font-family: math;
          color:black
        }

        @media (max-width: 992px) {
          .card-section {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 600px) {
          .filter-container {
            flex-direction: column;
          }

          .sidebar {
             width: 98%;
             position: relative;
             top: auto;
           }


@media (max-width: 480px) {
          .filter-container {
            flex-direction: column;
          }

          .sidebar {
             width: 98%;
             position: relative;
             top: auto;
           }


             .card{
             width:98%;
             }

          .card-section {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div style={{marginTop:'-314px',left:'-2px'}}>
      <OnlyButtonrange />
      </div>
    
    </div>
  );
};

export default BranchFilterComponent;



 



